import { render, staticRenderFns } from "./quote-item-card.vue?vue&type=template&id=4f1e959c&scoped=true&lang=pug"
import script from "./quote-item-card.vue?vue&type=script&lang=js"
export * from "./quote-item-card.vue?vue&type=script&lang=js"
import style0 from "./quote-item-card.vue?vue&type=style&index=0&id=4f1e959c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1e959c",
  null
  
)

export default component.exports